// extracted by mini-css-extract-plugin
module.exports = {"container":"item-module--container--3Frho","image":"item-module--image--1mSsu","overlay":"item-module--overlay--1DykI","text":"item-module--text--1GqpW"};